<template>
  <div
    class="flex w-full flex-1 flex-col items-center px-6 pt-[60px] tablet-v:pt-[100px]"
  >
    <div class="flex w-full max-w-[450px] flex-grow flex-col">
      <h1
        class="mx-auto mb-5 max-w-[340px] text-center text-[22px] font-medium leading-[26px] text-gray-800 tablet-v:max-w-full"
      >
        {{ title }}
      </h1>

      <div class="mt-auto w-full">
        <div class="mb-[30px] flex flex-col gap-[9px]">
          <slot />
        </div>

        <Button
          class="w-full"
          variant="primary"
          size="lg"
          :disabled="disabled"
          @click="$emit('next')"
        >
          Next
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@dacr/library'

defineProps<{
  title: string
  disabled?: boolean
}>()

defineEmits<{
  (e: 'next'): void
}>()
</script>
